export default __webpack_public_path__ + "static/media/card-front-square.776b46ff.jpg";